import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";

import "tippy.js/dist/tippy.css";
import "tippy.js/themes/material.css";

import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import AccountCircle from "@mui/icons-material/AccountCircle";
import ToyCard from "./toy-card";
import LoadingSpinner from "../common/loading";
import AddToyDialog from "./add-toy-dialog";
import { useWebSocket } from "../ws/websocket";
import { useEventEmitter } from "../ws/event-context";
import { useBackdrop } from "../common/backdrop";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import { useRecoilState } from "recoil";
import { userInfoState } from "../global-state";
import { useHistory } from "react-router-dom";
import UserAuth from "../auth/user-auth";
import MenuItem from "@mui/material/MenuItem";

const PlaygroundView = () => {
  const { openBackdrop, closeBackdrop } = useBackdrop();
  const {
    connectWebSocket,
    disconnectWebSocket,
    wsReady,
    sendAndWaitWs,
    sendAndForgetWs,
  } = useWebSocket();
  const { subscribe } = useEventEmitter();
  const history = useHistory();
  const [playgroundLoading, setPlaygroundLoading] = useState(true);
  const [playgroundToyMap, setPlaygroundToyMap] = useState(new Map());
  const [playgroundToyList, setPlaygroundToyList] = useState([]);
  const [toyFunctions, setToyFunctions] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [userAuthState, setUserAuthState] = useState("");
  const [userInfo, setUserInfo] = useRecoilState(userInfoState);
  const [scope, setScope] = useState("");

  useEffect(() => {
    const initializeAuth = async () => {
      const authResult = await UserAuth.checkUserAuthState();
      setUserAuthState(authResult.isAuthenticated ? "yes" : "no");
      console.log(111);
      if (authResult.isAuthenticated) {
        setUserInfo(authResult.userInfo);
        console.log(authResult.userInfo);
        connectWebSocket(authResult.userInfo);
      }
      console.log(1112);
    };

    initializeAuth();
  }, []);

  useEffect(() => {
    if (userAuthState === "yes" && wsReady) {
      setScope(userInfo.activeScope.id);
      getPlayground();
    }
  }, [userAuthState, wsReady]);

  useEffect(() => {
    const { unsubscribe: s1 } = subscribe((target, data) => {
      if (target === "_closed_") {
        // openBackdrop('Connecting...');
      }
    });

    const { unsubscribe: s2 } = subscribe((target, data) => {
      if (target === "/playground/update") {
        const payload = JSON.parse(data.payload);
        playgroundToyMap.set(payload.name, payload);
        const ta = Array.from(playgroundToyMap.entries())
          .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
          .map(([key, value]) => value);
        setPlaygroundToyList(ta);
      }
    });
    return () => {
      s1();
      s2();
    };
  }, []);

  // useEffect(() => {
  //     let pollInterval;
  //     const pollWebSocket = async () => {
  //         if (ws && ws.readyState === WebSocket.OPEN) {
  //             clearInterval(pollInterval);
  //             closeBackdrop();
  //             await getPlayground();
  //         }
  //     };
  //     pollInterval = setInterval(pollWebSocket, 500);
  //
  //     return () => {
  //         clearInterval(pollInterval);
  //     };
  // }, [ws]);

  const getPlayground = async () => {
    try {
      setPlaygroundLoading(true);
      const response = await sendAndWaitWs(
        "/playground/read",
        JSON.stringify({}),
      );
      if (response.error) {
        throw new Error(response.error);
      }
      const jsonData = JSON.parse(response.payload);
      console.log(jsonData);
      playgroundToyMap.clear();
      for (let i = 0; i < jsonData.toys.length; i++) {
        playgroundToyMap.set(jsonData.toys[i].name, jsonData.toys[i]);
      }
      const ta = Array.from(playgroundToyMap.entries())
        .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
        .map(([key, value]) => value);
      setPlaygroundToyList(ta);
      console.log(ta);

      setToyFunctions(jsonData.functions || []);
      setPlaygroundLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleLogin = async () => {
    await UserAuth.signIn(history);
  };

  const handleLogout = async () => {
    await UserAuth.signOut();
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleAddToy = async (name, functions) => {
    try {
      const response = await sendAndWaitWs(
        "/playground/create",
        JSON.stringify({
          name,
          functions,
        }),
      );
      if (response.error) {
        throw new Error(response.error);
      }
      const jsonData = JSON.parse(response.payload);
      getPlayground();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleDeleteToy = async name => {
    try {
      const response = await sendAndWaitWs(
        "/playground/delete",
        JSON.stringify({
          name,
        }),
      );
      if (response.error) {
        throw new Error(response.error);
      }
      const jsonData = JSON.parse(response.payload);
      getPlayground();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleUpdateToy = async updatedToy => {
    try {
      await sendAndForgetWs(
        "/playground/update",
        JSON.stringify({
          toy: updatedToy,
        }),
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleToyFunctionEvent = async (name, func) => {
    try {
      const resp = await sendAndForgetWs(
        "/playground/trigger",
        JSON.stringify({
          name,
          function: func,
        }),
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div>
      {userAuthState === "no" ? (
        <Box sx={{ padding: 4 }}>
          <Typography variant="h6">
            Playground provides virtual devices for testing usage. The devices
            are bound to a user scope. Please login with your personal account
            and choose the target scope.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleLogin}
            sx={{ marginTop: 2 }}
          >
            Login
          </Button>
        </Box>
      ) : (
        <>
          {userAuthState === "yes" && (
            <div>
              <Grid container alignItems="center">
                <Grid item>
                  <AccountCircle sx={{ fontSize: 30 }} />
                </Grid>

                <Grid item xs>
                  <Grid container spacing={2}>
                    <Grid item xs>
                      <TextField
                        variant="outlined"
                        value={userInfo.name}
                        disabled
                        size="small"
                        sx={{ marginLeft: "20px" }}
                      />
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleLogout}
                      >
                        Logout
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                container
                alighItem="center"
                marginBottom="15px"
                marginTop="15px"
              >
                <Typography
                  variant="body1"
                  component="div"
                  style={{
                    width: "50px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Home
                </Typography>
                <Select
                  value={scope}
                  onChange={e => setScope(e.target.value)}
                  displayEmpty
                  inputProps={{ "aria-label": "Select scope" }}
                  sx={{
                    height: "40px",
                    minWidth: 180,
                  }}
                >
                  {userInfo.scopes.map(userScope => (
                    <MenuItem key={userScope.id} value={userScope.id}>
                      {userScope.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              {playgroundLoading ? (
                <LoadingSpinner />
              ) : (
                <Box sx={{ flexGrow: 1 }}>
                  <Grid
                    container
                    spacing={{ xs: 3, md: 4 }}
                    columns={{ xs: 2, sm: 4, md: 12 }}
                  >
                    {playgroundToyList.map((toy, index) => (
                      <Grid item xs={2} sm={2} md={4} key={index}>
                        <ToyCard
                          toy={toy}
                          onUpdate={handleUpdateToy}
                          onSendEvent={handleToyFunctionEvent}
                          onDelete={handleDeleteToy}
                        />
                      </Grid>
                    ))}
                  </Grid>
                  <Fab
                    sx={{ position: "fixed", bottom: 30, right: 20 }}
                    color="primary"
                    aria-label="add"
                    onClick={handleOpenDialog}
                  >
                    <AddIcon />
                  </Fab>
                  <AddToyDialog
                    open={openDialog}
                    features={toyFunctions}
                    onClose={handleCloseDialog}
                    onSave={handleAddToy}
                  />
                </Box>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PlaygroundView;
